(function () {
    var API_URL = 'https://nfo-ai-assistant-production.up.railway.app/chat';
    var SESSION_KEY = 'nfo_ai_session_id';
    var HISTORY_KEY = 'nfo_ai_history';
    var OPEN_KEY = 'nfo_ai_open';
    var MAX_HISTORY = 40;
    var GREETING = 'Здравствуйте! Я ИИ-ассистент NFO. Помогу выбрать витамины, расскажу про состав, доставку и оплату.';
    function lsGet(key) {
    try { return localStorage.getItem(key); } catch (e) { return null; }
    }
    function lsSet(key, value) {
    try { localStorage.setItem(key, value); } catch (e) {}
    }
    function getSessionId() {
    var id = lsGet(SESSION_KEY);
    if (!id) {
    id = (window.crypto && crypto.randomUUID) ? crypto.randomUUID() : ('sid-' + Date.now() + '-' + Math.random().toString(36).slice(2));
    lsSet(SESSION_KEY, id);
    }
    return id;
    }
    var sessionId = getSessionId();
    var isSending = false;
    var history = [];
    try { history = JSON.parse(lsGet(HISTORY_KEY) || '[]') || []; } catch (e) { history = []; }
    if (!Array.isArray(history)) history = [];
    function saveHistory() {
    if (history.length > MAX_HISTORY) history = history.slice(history.length - MAX_HISTORY);
    lsSet(HISTORY_KEY, JSON.stringify(history));
    }
    function escapeHtml(s) {
    return String(s == null ? '' : s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
    }
    function safeUrl(u) {
    var url = String(u || '').trim();
    if (/^https?:\/\//i.test(url) || url.charAt(0) === '/') return url;
    return null;
    }
    function isSameSite(url) {
    return url.charAt(0) === '/' || url.indexOf(location.host) !== -1;
    }
    function renderMarkdown(text) {
    var html = escapeHtml(text);
    html = html.replace(/\[([^\]]+)\]\(([^)\s]+)\)/g, function (m, label, url) {
    var safe = safeUrl(url);
    if (!safe) return label;
    var attrs = isSameSite(safe) ? '' : ' target="_blank" rel="noopener"';
    return '<a href="' + safe + '"' + attrs + '>' + label + '</a>';
    });
    html = html.replace(/\*\*([^*]+)\*\*/g, '<strong>$1</strong>');
    html = html.replace(/(^|[\s(])\*([^*\n]+)\*/g, '$1<em>$2</em>');
    html = html.replace(/^#{1,6}\s*/gm, '');
    return html;
    }
    var root = document.createElement('div');
    root.className = 'nfo-aiw-root';
    root.innerHTML =
    '<button type="button" class="nfo-aiw-launcher" aria-label="Открыть ИИ-консультанта NFO">' +
    '<svg class="nfo-aiw-chat-icon" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">' +
    '<path d="M10 2.5l1.9 5.3 5.3 1.9-5.3 1.9L10 16.9l-1.9-5.3-5.3-1.9 5.3-1.9z"></path>' +
    '<path d="M18.5 13.5l.9 2.4 2.4.9-2.4.9-.9 2.4-.9-2.4-2.4-.9 2.4-.9z"></path></svg>' +
    '<span class="nfo-aiw-launcher-label">ИИ-консультант</span>' +
    '<svg class="nfo-aiw-close-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">' +
    '<line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg>' +
    '</button>' +
    '<div class="nfo-aiw-panel" role="dialog" aria-label="Чат с ИИ-ассистентом NFO">' +
    '<div class="nfo-aiw-header">' +
    '<div class="nfo-aiw-header-left">' +
    '<span class="nfo-aiw-avatar"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><rect x="4" y="8" width="16" height="11" rx="3"></rect><circle cx="9" cy="13" r="1.3" fill="currentColor" stroke="none"></circle><circle cx="15" cy="13" r="1.3" fill="currentColor" stroke="none"></circle><path d="M12 8V5"></path><circle cx="12" cy="4" r="1.2" fill="currentColor" stroke="none"></circle></svg></span>' +
    '<span><span class="nfo-aiw-header-title">ИИ-ассистент NFO</span><span class="nfo-aiw-header-sub">Отвечает на вопросы о продукции</span></span>' +
    '</div>' +
    '<button type="button" class="nfo-aiw-header-close" aria-label="Закрыть чат">' +
    '<svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg>' +
    '</button>' +
    '</div>' +
    '<div class="nfo-aiw-body" id="nfo-aiw-body"></div>' +
    '<p class="nfo-aiw-note">Нужен живой менеджер — ассистент даст кнопку WhatsApp. Этот чат ведёт ИИ.</p>' +
    '<div class="nfo-aiw-footer">' +
    '<textarea class="nfo-aiw-input" id="nfo-aiw-input" rows="1" placeholder="Напишите вопрос…"></textarea>' +
    '<button type="button" class="nfo-aiw-send" id="nfo-aiw-send" aria-label="Отправить">' +
    '<svg viewBox="0 0 24 24" fill="currentColor"><path d="M2 21l21-9L2 3v7l15 2-15 2z"></path></svg>' +
    '</button>' +
    '</div>' +
    '<p class="nfo-aiw-disclaimer">Отвечает ИИ-ассистент. Ответы могут содержать неточности.</p>' +
    '</div>';
    document.body.appendChild(root);
    var launcher = root.querySelector('.nfo-aiw-launcher');
    var closeBtn = root.querySelector('.nfo-aiw-header-close');
    var body = root.querySelector('#nfo-aiw-body');
    var input = root.querySelector('#nfo-aiw-input');
    var sendBtn = root.querySelector('#nfo-aiw-send');
    function scrollToEnd() { body.scrollTop = body.scrollHeight; }
    function paintMessage(role, text, url) {
    var el = document.createElement('div');
    if (role === 'user') {
    el.className = 'nfo-aiw-msg nfo-aiw-msg-user';
    el.textContent = text;
    } else if (role === 'system') {
    el.className = 'nfo-aiw-msg nfo-aiw-msg-system';
    el.textContent = text;
    } else if (role === 'cart') {
    el.className = 'nfo-aiw-cart-note';
    el.textContent = text;
    } else if (role === 'wa') {
    el.className = 'nfo-aiw-wa-wrap';
    var a = document.createElement('a');
    a.href = url || '#';
    a.target = '_blank';
    a.rel = 'noopener';
    a.className = 'nfo-aiw-wa-btn';
    a.textContent = 'Написать в WhatsApp';
    el.appendChild(a);
    } else {
    el.className = 'nfo-aiw-msg nfo-aiw-msg-bot';
    el.innerHTML = renderMarkdown(text);
    }
    body.appendChild(el);
    scrollToEnd();
    return el;
    }
    function addMessage(role, text, url) {
    var el = paintMessage(role, text, url);
    history.push({ r: role, t: text, u: url || '' });
    saveHistory();
    return el;
    }
    function restoreHistory() {
    if (!history.length) {
    addMessage('bot', GREETING);
    return;
    }
    history.forEach(function (m) { paintMessage(m.r, m.t, m.u); });
    }
    function addTypingBubble() {
    var el = document.createElement('div');
    el.className = 'nfo-aiw-msg nfo-aiw-msg-bot is-typing';
    el.innerHTML = '<span class="nfo-aiw-dots"><span class="nfo-aiw-dot"></span><span class="nfo-aiw-dot"></span><span class="nfo-aiw-dot"></span></span>';
    body.appendChild(el);
    scrollToEnd();
    return el;
    }
    function toggle(open) {
    var next = (typeof open === 'boolean') ? open : !root.classList.contains('is-open');
    root.classList.toggle('is-open', next);
    lsSet(OPEN_KEY, next ? '1' : '0');
    if (next) {
    scrollToEnd();
    setTimeout(function () { input.focus(); scrollToEnd(); }, 200);
    }
    }
    launcher.addEventListener('click', function () { toggle(); });
    closeBtn.addEventListener('click', function () { toggle(false); });
    function addToCart(variantId, quantity) {
    return fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ items: [{ id: variantId, quantity: quantity || 1 }] })
    }).then(function (res) {
    if (!res.ok) throw new Error('cart add failed');
    return res.json();
    });
    }
    function refreshCartCount() {
    fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
    document.querySelectorAll('[data-cart-count], .cart-count-bubble span').forEach(function (elC) {
    elC.textContent = cart.item_count;
    });
    try {
    if (typeof window.publish === 'function' && window.PUB_SUB_EVENTS && window.PUB_SUB_EVENTS.cartUpdate) {
    window.publish(window.PUB_SUB_EVENTS.cartUpdate, { source: 'nfo-ai-widget', cartData: cart });
    }
    } catch (e) {}
    }).catch(function () {});
    }
    function handleAction(action) {
    if (!action) return;
    if (action.type === 'add_to_cart') {
    addToCart(action.variant_id, action.quantity).then(function () {
    addMessage('cart', 'Добавлено в корзину: ' + (action.title || 'товар') + (action.quantity > 1 ? ' × ' + action.quantity : ''));
    refreshCartCount();
    }).catch(function () {
    addMessage('system', 'Не получилось добавить товар в корзину. Попробуйте вручную на странице товара.');
    });
    } else if (action.type === 'escalate') {
    addMessage('wa', 'whatsapp', action.whatsapp_url);
    }
    }
    function sendMessage() {
    var text = input.value.trim();
    if (!text || isSending) return;
    isSending = true;
    sendBtn.disabled = true;
    addMessage('user', text);
    input.value = '';
    input.style.height = 'auto';
    var typingEl = addTypingBubble();
    var answerEl = null;
    var buffer = '';
    function processEvent(chunk) {
    var eventName = 'message';
    var dataLines = [];
    chunk.split('\n').forEach(function (line) {
    if (line.indexOf('event:') === 0) eventName = line.slice(6).trim();
    else if (line.indexOf('data:') === 0) dataLines.push(line.slice(5).trim());
    });
    if (!dataLines.length) return;
    var data;
    try { data = JSON.parse(dataLines.join('\n')); } catch (e) { return; }
    if (eventName === 'token') {
    if (typingEl && typingEl.parentNode) { typingEl.parentNode.removeChild(typingEl); typingEl = null; }
    if (!answerEl) {
    answerEl = document.createElement('div');
    answerEl.className = 'nfo-aiw-msg nfo-aiw-msg-bot';
    body.appendChild(answerEl);
    }
    buffer += data.text || '';
    answerEl.innerHTML = renderMarkdown(buffer);
    scrollToEnd();
    } else if (eventName === 'action') {
    handleAction(data);
    } else if (eventName === 'error') {
    if (typingEl && typingEl.parentNode) { typingEl.parentNode.removeChild(typingEl); typingEl = null; }
    addMessage('system', data.error || 'Произошла ошибка.');
    }
    }
    function finish() {
    isSending = false;
    sendBtn.disabled = false;
    if (typingEl && typingEl.parentNode) typingEl.parentNode.removeChild(typingEl);
    if (buffer) { history.push({ r: 'bot', t: buffer, u: '' }); saveHistory(); }
    }
    fetch(API_URL, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ session_id: sessionId, message: text })
    }).then(function (res) {
    if (!res.ok || !res.body) throw new Error('bad response');
    var reader = res.body.getReader();
    var decoder = new TextDecoder();
    var pending = '';
    function readChunk() {
    return reader.read().then(function (result) {
    if (result.done) return;
    pending += decoder.decode(result.value, { stream: true });
    var parts = pending.split('\n\n');
    pending = parts.pop();
    parts.forEach(processEvent);
    return readChunk();
    });
    }
    return readChunk();
    }).then(finish).catch(function () {
    finish();
    addMessage('system', 'Не удалось получить ответ. Попробуйте ещё раз чуть позже.');
    });
    }
    sendBtn.addEventListener('click', sendMessage);
    input.addEventListener('keydown', function (e) {
    if (e.key === 'Enter' && !e.shiftKey) {
    e.preventDefault();
    sendMessage();
    }
    });
    input.addEventListener('input', function () {
    input.style.height = 'auto';
    input.style.height = Math.min(input.scrollHeight, 90) + 'px';
    });
    restoreHistory();
    if (lsGet(OPEN_KEY) === '1') toggle(true);
    })();